import React, { useState, useEffect } from 'react';

const CalendarComponent = () => {
  const [selectedDates, setSelectedDates] = useState([]);  // Dates user selects to disable
  const [highlightedDates, setHighlightedDates] = useState([]);  // Dates from API
  const [currentDate, setCurrentDate] = useState(new Date());
  const [selectedHighlightedUIDs, setSelectedHighlightedUIDs] = useState([]); // UIDs to delete
  const [unblockedDates, setUnblockedDates] = useState([]); // Add this line
  const userID = localStorage.getItem('userID');

  // Fetch the holiday dates from the API
  useEffect(() => {
    const fetchHolidayDates = async () => {
      try {
        const currDate = `${String(currentDate.getMonth() + 1).padStart(2, '0')}-${currentDate.getFullYear()}`;
        const response = await fetch(`https://xianhefairy.com/LotusFairy_API/api/Booking/GetHolidayDate?MasterId=${userID}&CurrDate=${currDate}`);
        if (!response.ok) {
          throw new Error('Failed to fetch holiday dates');
        }
        const apiData = await response.json();
        console.log('API Response:', apiData);

        // Parse LeaveDate (format: "19-11-2025") and set them as highlighted dates
        const highlighted = apiData.map(data => {
          // Split by hyphen: "19-11-2025" -> ["19", "11", "2025"]
          const parts = data.LeaveDate.split('-');
          const day = parseInt(parts[0], 10);
          const month = parseInt(parts[1], 10) - 1;  // Month is 0-indexed
          const year = parseInt(parts[2], 10);
          
          console.log('Parsed date:', { day, month, year, original: data.LeaveDate });
          
          return {
            day,
            month,
            year,
            uid: data.Uid
          };
        });

        console.log('Final highlighted dates array:', apiData.map(d => d.Uid));
        console.log('Highlighted dates:', highlighted);
        setHighlightedDates(highlighted);
      } catch (error) {
        console.error('Error fetching holiday dates from API:', error);
      }
    };

    fetchHolidayDates();
  }, [currentDate, userID]); // Re-fetch when month/year changes

  // Function to check if a date is in the past or today
  const isPastDate = (day) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Reset time to 00:00:00
    const dateToCheck = new Date(currentDate.getFullYear(), currentDate.getMonth(), day);
    dateToCheck.setHours(0, 0, 0, 0); // Reset time for the checked date
    return dateToCheck <= today; // Disable past and today's date
  };

  // Handle month change
  const handleMonthChange = (offset) => {
    setCurrentDate(prevDate => {
      const newDate = new Date(prevDate);
      newDate.setMonth(prevDate.getMonth() + offset);
      return newDate;
    });
  };

  // Handle year change
  const handleYearChange = (offset) => {
    setCurrentDate(prevDate => {
      const newDate = new Date(prevDate);
      newDate.setFullYear(prevDate.getFullYear() + offset);
      return newDate;
    });
  };

  // Simulates getting all days in the current month
  const daysInMonth = () => {
    const days = [];
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth();
    const daysInCurrentMonth = new Date(year, month + 1, 0).getDate();
    for (let day = 1; day <= daysInCurrentMonth; day++) {
      days.push(day);
    }
    return days;
  };

  // Number of blank cells needed before day 1 so it lines up under the right weekday
  const firstWeekdayOffset = () => {
    return new Date(currentDate.getFullYear(), currentDate.getMonth(), 1).getDay();
  };

  const weekdayLabels = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

  const [bookedDates, setBookedDates] = useState([]); // Add this line

  useEffect(() => {
    // Fetch booked dates
    const fetchBookedDates = async () => {
      try {
        const response = await fetch(`https://xianhefairy.com/LotusFairy_API/api/Booking/getBD?ID=${userID}`);
        if (!response.ok) throw new Error('Failed to fetch booked dates');
        const data = await response.json();
        // Parse REC_DATE to Date objects (YYYY-MM-DD)
        const booked = data.map(item => {
          const dateStr = item.REC_DATE.split('T')[0]; // "2025-11-19"
          const [year, month, day] = dateStr.split('-').map(Number);
          return { year, month: month - 1, day }; // month is 0-indexed
        });
        setBookedDates(booked);
      } catch (error) {
        console.error('Error fetching booked dates:', error);
      }
    };
    fetchBookedDates();
  }, [userID, currentDate]);

  // Helper to check if a day is booked
  const isBookedDate = (day) => {
    return bookedDates.some(
      d => d.day === day && d.month === currentDate.getMonth() && d.year === currentDate.getFullYear()
    );
  };


  const postDisableDates = async (dates) => {
    const MasterId = Number(localStorage.getItem('userID'));
    const body = dates.map(date => ({
      MasterId,
      Type: 0,
      LeaveDate: date
    }));
    try {
      const response = await fetch('https://xianhefairy.com/LotusFairy_API/api/Booking/MasterHolidayUpdate', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      });
      if (!response.ok) throw new Error('Failed to disable dates');
      // Refresh highlighted dates
      const currDate = `${String(currentDate.getMonth() + 1).padStart(2, '0')}-${currentDate.getFullYear()}`;
      const refreshResponse = await fetch(`https://xianhefairy.com/LotusFairy_API/api/Booking/GetHolidayDate?MasterId=${userID}&CurrDate=${currDate}`);
      const apiData = await refreshResponse.json();
      const highlighted = apiData.map(data => {
        const parts = data.LeaveDate.split('-');
        return {
          day: parseInt(parts[0], 10),
          month: parseInt(parts[1], 10) - 1,
          year: parseInt(parts[2], 10),
          uid: data.Uid
        };
      });
      setHighlightedDates(highlighted);
    } catch (error) {
      console.error(error);
    }
  };

  const toggleDateSelection = (day) => {
    if (isBookedDate(day)) return; // Prevent disabling booked dates

    const selectedDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), day);
    const isHighlighted = highlightedDates.some(
      d => d.day === day && d.month === currentDate.getMonth() && d.year === currentDate.getFullYear()
    );
    
    console.log('Toggle date:', day, 'isHighlighted:', isHighlighted);
  
    if (!isPastDate(day)) {
      // Unblock highlighted dates (turn them white)
      if (isHighlighted) {
        setHighlightedDates(highlightedDates.filter(
          d => !(d.day === day && d.month === currentDate.getMonth() && d.year === currentDate.getFullYear())
        ));
        setUnblockedDates([...unblockedDates, selectedDate]);  // Add to unblocked dates
      } else if (selectedDates.includes(day)) {
        setSelectedDates(selectedDates.filter(selectedDay => selectedDay !== day));
      } else {
        setSelectedDates([...selectedDates, day]);
      }
    }
  };

  // Select highlighted day for deletion
  const selectHighlightedDay = (day) => {
    const highlighted = highlightedDates.find(
      d => d.day === day && d.month === currentDate.getMonth() && d.year === currentDate.getFullYear()
    );
    if (highlighted) {
      setSelectedHighlightedUIDs(prev =>
        prev.includes(highlighted.uid)
          ? prev.filter(uid => uid !== highlighted.uid)
          : [...prev, highlighted.uid]
      );
    }
  };

  // Delete selected highlighted days
  const deleteHighlightedDays = async () => {
    if (selectedHighlightedUIDs.length === 0) return;
    const uidParam = selectedHighlightedUIDs.join(',');
    try {
      const response = await fetch(
        `https://xianhefairy.com/LotusFairy_API/api/Booking/MasterHolidayDelete?uid=${uidParam}`,
        { method: 'POST' } // POST, no body
      );
      if (!response.ok) throw new Error('Failed to delete disabled days');
      // Refresh highlighted dates
      const currDate = `${String(currentDate.getMonth() + 1).padStart(2, '0')}-${currentDate.getFullYear()}`;
      const refreshResponse = await fetch(`https://xianhefairy.com/LotusFairy_API/api/Booking/GetHolidayDate?MasterId=${userID}&CurrDate=${currDate}`);
      const apiData = await refreshResponse.json();
      const highlighted = apiData.map(data => {
        const parts = data.LeaveDate.split('-');
        return {
          day: parseInt(parts[0], 10),
          month: parseInt(parts[1], 10) - 1,
          year: parseInt(parts[2], 10),
          uid: data.Uid
        };
      });
      setHighlightedDates(highlighted);
      setSelectedHighlightedUIDs([]);
      alert('Highlighted days deleted!');
    } catch (error) {
      console.error(error);
      alert('Failed to delete disabled days.');
    }
  };
  
  const confirmSelection = async () => {
    const MasterId = Number(localStorage.getItem('userID'));
    
    // Prepare dates to disable (selected dates) - Format: YYYY-MM-DD
    const datesToDisable = selectedDates.map((day) => {
      const date = new Date(currentDate.getFullYear(), currentDate.getMonth(), day);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const dayFormatted = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${dayFormatted}`;  // Changed format to YYYY-MM-DD
    });

    // Prepare dates to unblock (highlighted dates that were clicked) - Format: YYYY-MM-DD
    const datesToUnblock = unblockedDates.map((date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;  // Changed format to YYYY-MM-DD
    });

    // Disable selected dates
    if (datesToDisable.length > 0) {
      await postDisableDates(datesToDisable);
    }

    // Unblock dates
    if (datesToUnblock.length > 0) {
      const unblockPromises = datesToUnblock.map(async (dateStr) => {
        const unblockData = {
          MasterId,
          Type: 0,
          LeaveDate: dateStr
        };

        try {
          const response = await fetch('https://xianhefairy.com/LotusFairy_API/api/Booking/MasterHolidayUpdate', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify([unblockData]),
          });

          if (!response.ok) {
            throw new Error(`Failed to unblock date ${dateStr}`);
          }
          const result = await response.json();
          console.log(`Successfully unblocked date ${dateStr}:`, result);
        } catch (error) {
          console.error(`Error unblocking date ${dateStr}:`, error);
        }
      });

      await Promise.all(unblockPromises);
      
      // Refresh the highlighted dates after unblocking
      const currDate = `${String(currentDate.getMonth() + 1).padStart(2, '0')}-${currentDate.getFullYear()}`;
      const refreshResponse = await fetch(`https://xianhefairy.com/LotusFairy_API/api/Booking/GetHolidayDate?MasterId=${userID}&CurrDate=${currDate}`);
      const apiData = await refreshResponse.json();
      const highlighted = apiData.map(data => {
        const parts = data.LeaveDate.split('-');
        return {
          day: parseInt(parts[0], 10),
          month: parseInt(parts[1], 10) - 1,
          year: parseInt(parts[2], 10)
        };
      });
      setHighlightedDates(highlighted);
    }

    // Clear selections after confirmation
    setSelectedDates([]);
    setUnblockedDates([]);
    
    // Optionally refresh the highlighted dates
    alert('Dates updated successfully!');
  };

  return (
    <div style={{ textAlign: 'center', padding: '20px' }}>
      <h4>Select Dates to Disable</h4>

      {/* Header for month and year navigation */}
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '20px' }}>
        <button onClick={() => handleMonthChange(-1)} style={{ marginRight: '10px', border: 'none', backgroundColor: 'transparent' }}>◄</button>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <button onClick={() => handleYearChange(-1)} style={{ marginRight: '5px', border: 'none', backgroundColor: 'transparent' }}>◄◄</button>
          <span style={{ margin: '0 10px' }}>
            {currentDate.toLocaleString('default', { month: 'long' })} {currentDate.getFullYear()}
          </span>
          <button onClick={() => handleYearChange(1)} style={{ marginLeft: '5px', border: 'none', backgroundColor: 'transparent' }}>►►</button>
        </div>
        <button onClick={() => handleMonthChange(1)} style={{ marginLeft: '10px', border: 'none', backgroundColor: 'transparent' }}>►</button>
      </div>

      <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(7, 1fr)',
          gap: '4px',
            justifyContent: 'center',
          width: '100%',
          maxWidth: '100%',
            margin: '0 auto 4px'
          }}>
        {weekdayLabels.map((label) => (
          <div key={label} style={{ textAlign: 'center', fontWeight: 'bold', fontSize: '13px' }}>
            {label}
          </div>
        ))}
      </div>

      <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(7, 1fr)',
          gap: '4px',
            justifyContent: 'center',
          width: '100%',
          maxWidth: '100%',
            margin: '0 auto'
          }}>
        {Array.from({ length: firstWeekdayOffset() }).map((_, i) => (
          <div key={`empty-${i}`} />
        ))}
        {daysInMonth().map((day) => {
          const highlighted = highlightedDates.find(
            d => d.day === day && d.month === currentDate.getMonth() && d.year === currentDate.getFullYear()
          );
          const isHighlighted = !!highlighted;
          const isSelectedForDelete = highlighted && selectedHighlightedUIDs.includes(highlighted.uid);
          const isBooked = isBookedDate(day);

          return (
            <div
              key={day}
              onClick={() => {
                if (isBooked) return; // Prevent click on booked dates

                if (isHighlighted) {
                  setSelectedHighlightedUIDs(prev => {
                    let newSelection;
                    if (prev.includes(highlighted.uid)) {
                      newSelection = prev.filter(uid => uid !== highlighted.uid);
                    } else {
                      newSelection = [...prev, highlighted.uid];
                    }
                    console.log('Selected highlighted date:', highlighted, 'Selected UIDs:', newSelection);
                    return newSelection;
                  });
                } else if (!isPastDate(day)) {
                  toggleDateSelection(day);
                }
              }}
              style={{
                backgroundColor: isBooked
                  ? '#e4bcbcff' // Red for booked
                  : isHighlighted
                  ? isSelectedForDelete ? '#ffcccc' : '#FFD700'
                  : isPastDate(day)
                  ? '#d3d3d3'
                  : selectedDates.includes(day)
                  ? 'lightgreen'
                  : '#d3d3d3',
                color: isBooked
                  ? '#fff'
                  : isHighlighted
                  ? '#000'
                  : isPastDate(day)
                  ? '#808080'
                  : selectedDates.includes(day)
                  ? '#000'
                  : '#000',
                width: '100%',
                minWidth: 0,
                height: '40px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                margin: 0,
                border: isSelectedForDelete ? '2px solid #ff0000' : '1px solid #ccc',
                borderRadius: '5px',
                pointerEvents: isPastDate(day) || isBooked ? 'none' : 'auto',
                cursor: isPastDate(day) || isBooked ? 'not-allowed' : 'pointer',
                boxSizing: 'border-box',
                userSelect: 'none'
              }}
              title={isBooked ? 'Booked (cannot disable)' : isHighlighted ? 'Holiday (click to select for delete)' : ''}
            >
              {day}
            </div>
          );
        })}
      </div>

      <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', marginTop: '20px' }}>
        <button onClick={confirmSelection} style={{ padding: '10px 20px', fontSize: '16px', borderRadius:'15px' }}>
          Confirm Selection
        </button>
        <button
          onClick={deleteHighlightedDays}
          style={{
            padding: '10px 20px',
            fontSize: '16px',
            borderRadius: '15px',
            backgroundColor: selectedHighlightedUIDs.length > 0 ? '#ff4444' : '#ccc',
            color: '#fff',
            border: 'none',
            cursor: selectedHighlightedUIDs.length > 0 ? 'pointer' : 'not-allowed'
          }}
          disabled={selectedHighlightedUIDs.length === 0}
        >
          Delete Disabled Day
        </button>
      </div>
    </div>
  );
};

export default CalendarComponent;